import { tap, withLatestFrom } from 'rxjs';
import { enterPressed } from '@ardoq/dropdown-menu';
import {
  action$,
  dispatchAction,
  extractPayload,
  ofType,
  withNamespace,
} from '@ardoq/rxbeach';
import { GetAdditionalRoutineArgs } from '../../types';
import { NodeModelTypes } from '../../utils/consts';
import { parentSelected } from '../../actions';

export const getHandleEnterPressedRoutine = ({
  navigator$,
  navigatorConfiguration,
}: GetAdditionalRoutineArgs) =>
  action$.pipe(
    withNamespace(navigatorConfiguration.actionNamespace),
    ofType(enterPressed),
    extractPayload(),
    withLatestFrom(navigator$),
    tap(([{ nodeId }, state]) => {
      const highlightedNode = state.tree.getNode(
        nodeId || state.tree.keyboardSelectedNodeId || ''
      );
      if (!highlightedNode) {
        return;
      }
      if (highlightedNode.type === NodeModelTypes.COMPONENT) {
        dispatchAction(
          parentSelected({
            parentId: highlightedNode.id,
            parentName: highlightedNode.getName(),
          }),
          navigatorConfiguration.actionNamespace
        );
      }
      if (highlightedNode.type === NodeModelTypes.WORKSPACE) {
        dispatchAction(
          parentSelected(null),
          navigatorConfiguration.actionNamespace
        );
      }
    })
  );
